import { AddressResponse } from './interface';
import { request } from '@/utils/request';
import { BASE_URL } from '@/constants/endpoints';

export const getCoords = async (address: string): Promise<AddressResponse> => {
  const { data } = await request().get('/utils/address/term', {
    params: {
      page: 1,
      term: address
    }
  });
  return data.result;
};

export const getImageBuffer = async (token: string, imgUri: string) => {
  const response = await request(token).get(BASE_URL() + imgUri, {
    responseType: 'arraybuffer'
  });
  return response.data;
};

export const getBanks = async () => {
  const {
    data: { result }
  } = await request().get('/banks');
  const list = result.map((i: string) => {
    return { value: i, label: i };
  });
  return list;
};
export default { getCoords, getImageBuffer, getBanks };
